var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.globalLocationId)?_c('list-appointments',{attrs:{"start-at":_vm.startAtRef,"artist-id":_vm.artist.id,"location-id":_vm.globalLocationId}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }